export default "__VITE_ASSET__BYyyKEg4__"